<template>

  <div>
    <Panel class="">
      <PanelHeading title="subject.title" :subtitle="chapters.length +  ' chapter' + (chapters.length > 1 ? 's' : '')">
        <div slot="title">
          <div class="row">
            <div class="col-xs-12 col-sm-6">
              <span  v-on:click="toggleExpanded" class="expandButton">{{subject.title}}</span>
              <span v-on:click="toggleExpanded" class="expandButton">
                <span v-if="expanded" class="icon mdi mdi-chevron-down"></span>
                <span v-else class="icon mdi mdi-chevron-right"></span>
              </span>
            </div>
            <div class="col-xs-12 col-sm-6">
              <button class="btn btn-default select-all" @click="selectAll()">Select all</button>
            </div>

          </div>
        </div>
      </PanelHeading>

      <PanelBody v-if="expanded">
        <div v-for="chapter in chapters">
          <ChapterRow :chapter="chapter"></ChapterRow>
        </div>
      </PanelBody>

    </Panel>
  </div>
</template>

<script>
  import _ from 'underscore'
  import { mapState, mapGetters, mapActions } from 'vuex'
  import ChapterRow from './ChapterRow'

  export default {
    props: ['subject'],

    components: {
      ChapterRow
    },

    created() {
    },

    methods: {
      toggleExpanded() {
        this.expanded = !this.expanded;
      },
      selectAll() {
        const ids = _.pluck(this.chapters, 'id');
        this.$store.dispatch('addChaptersToExport', { chapterIds: ids })
      }
    },

    data() {
      return {
        expanded: true
      }
    },

    computed: {
      chapters() {
        const chapters = _.where(this.$store.getters.allChapters, { subject_id: this.subject.id });
        return chapters;
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .panel {box-shadow:none;padding:0px;}
  .panel .panel-heading {border-bottom:1px solid #EEEEEE;}
  .panel .panel-heading .expandButton {cursor:pointer;margin-right:10px;}
  .select-all { float: right; }
</style>



// WEBPACK FOOTER //
// SubjectRow.vue?0983e683